<template>
	<div class="modal modal-registrar is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Muito Bom! Agora só falta um detalhe:</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<section class="modal-card-body" >

				<p class="anonymousWarning"><a href="#" @click.prevent="identifyAnonymous">Para que suas configurações sejam salvas, você precisa estar registrado. Clique no botão abaixo para efetuar o registro rápido.<br> É grátis! </a></p>

			</section>

			<footer class="modal-card-foot">
				<label class="checkbox"><input type="checkbox" v-model="skipRegistrar"> Não exibir esta mensagem novamente</label>
				<button class="button is-success" @click.prevent="identifyAnonymous">Registrar</button>
			</footer>

		</div>
	</div>
</template>

<style>
.modal-registrar .anonymousWarning a { color:#333; font-size:20px;}

.modal-registrar .modal-card-foot {
	justify-content: space-between;
}
.modal-registrar {}


</style>

<script>

export default {
	data() {
		return {
			skipRegistrar:false,
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods:{
		identifyAnonymous(){
			this.$store.dispatch('anonymousRedirectLogin');
		},
		goBack(){
			if(this.skipRegistrar){
				this.$store.state.skipRegistrar = true;
			}
			this.$router.push({name:'home'});

		},
	}
};
</script>

